import styled from 'styled-components';

export const ContentModal = styled.div`
	text-align: center;

	button {
		display: flex;
		gap: 12px;
		height: 40px;
		width: 180px;

		svg {
			width: 18px;
			height: 18px;
		}
	}
`;

export const ContainerButton = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 24px;
`;
